import React, { Fragment } from 'react';

import Typography from '@material-ui/core/Typography';
import moment from 'moment';
import { useStyles, customCardStyles, vehicleStatusStyles } from './Services.styled';
import { Card } from 'components/UI';
import { withRouter } from 'react-router-dom';

import { useSelector } from 'react-redux';
import i18n from 'i18n-js';

import { Divider, List, ListItem } from '@material-ui/core';

const getVehicleStatus = (status, statusClasses) => {
  return (
    <Typography
      variant="inherit"
      className={`${statusClasses.vehicleStatus} ${statusClasses[status?.toLowerCase()] || ''}`}
    >
      {i18n.t(`vehicle_groups.status.${status}`, {
        defaultValue: status || '',
      })}
    </Typography>
  );
};

const VehicleServices = ({ services = [], menuOptions = [] }) => {
  const classes = useStyles();
  const cardClasses = customCardStyles();
  const statusClasses = vehicleStatusStyles();

  const localeFormat = useSelector((state) => state.organizations?.localeFormat);

  const servicesList =
    services
      ?.filter(
        (service) =>
          service?.organization?.org_type === 'service' ||
          service?.organization?.org_type === 'business'
      )
      ?.reduce((acc, service) => {
        if (acc[service?.organization.id]) {
          acc[service?.organization?.id].push(service);
        } else {
          acc[service?.organization?.id] = [];
          acc[service?.organization?.id].push(service);
        }
        return acc;
      }, {}) || {};

  return (
    <Card
      menuItems={menuOptions}
      title="Assigned Services"
      data-cy="assined-service-widget-card"
      headerActionType="vertical"
      contentRootClasses={cardClasses}
    >
      <List component="nav" aria-labelledby="nested-list-subheader" className={classes.root}>
        {Object.keys(servicesList).length > 0 ? (
          Object.keys(servicesList).map((serviceId, index) => {
            const firstService = servicesList[serviceId][0];
            const serviceObj = servicesList[serviceId];
            return (
              <Fragment key={index}>
                <>
                  <ListItem className={classes.listItem}>
                    <div className={classes.serviceTitle}>{firstService?.organization?.name}</div>
                    {serviceObj.map((service) => {
                      const endTime = moment(service.end_time);
                      const startTime = moment(service.start_time);
                      return (
                        <div className={classes.serviceRange} key={service.or}>
                          <span className={classes.serviceRangeDate}>
                            {`${i18n.t('common.from_start_time', {
                              startTime: startTime.format(localeFormat),
                            })} ${
                              service.end_time
                                ? i18n.t('common.till_end_time', {
                                    endTime: endTime.format(localeFormat),
                                  })
                                : ''
                            }`}
                          </span>
                          <span className={classes.serviceRangeStatus}>
                            {getVehicleStatus(service?.status, statusClasses) || '--'}
                          </span>
                        </div>
                      );
                    })}
                  </ListItem>
                  <Divider className={classes.divider} />
                </>
              </Fragment>
            );
          })
        ) : (
          <ListItem>{i18n.t('vehicle.empty_services')}</ListItem>
        )}
      </List>
    </Card>
  );
};

export default withRouter(VehicleServices);
